module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAIVBMVEUAAAA4bOk4bOg3bOg3bOg3a+hAYN83beg3a+Y1auo4bOi9wGRjAAAACnRSTlMA5PPPx0wIcHAYYzMOHwAAAGJJREFUOMtjGKwgcBUIqLSB2BlOYI4oWEJqFRgsnsDAwGkFYS8ES6yCAjMGhmQYG0ViOQNDFVaJJQwMXlglFjEwaKFKIHirRiVGJYaShBSqBCLjBGJKiKJmRqAUHFAuQQkAAEf4quy5X/n1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/book-open-fill-pre@2x.png
// module id = U8Tq
// module chunks = 44